type GroundCondition = {
    title: string
    image: string
    maxFreeFallHeight: number
}

export function useGroundConditions() {
    const groundConditions = computed<GroundCondition[]>(() => [
        {
            title: 'Beton',
            image: 'attr_677.svg',
            maxFreeFallHeight: 0.6,
        },
        {
            title: 'Fallschutzplatten',
            image: 'attr_683.svg',
            maxFreeFallHeight: 3,
        },
        {
            title: 'Rasen',
            image: 'attr_689.svg',
            maxFreeFallHeight: 1,
        },
        {
            title: 'Rasen (D)',
            image: 'attr_686.svg',
            maxFreeFallHeight: 1.5,
        },
        {
            title: 'Sand',
            image: 'attr_691.svg',
            maxFreeFallHeight: 3,
        },
        {
            title: 'Perlkies',
            image: 'attr_698.svg',
            maxFreeFallHeight: 3,
        },
        {
            title: 'Oberboden',
            image: 'attr_695.svg',
            maxFreeFallHeight: 1,
        },
    ]);

    return {groundConditions};
}
